export default __webpack_public_path__ + "static/machiavelli-5d60cee6c47c06bb341444806cb2227e.jpg";